import { render, staticRenderFns } from "./SetView.vue?vue&type=template&id=4fad91d7&"
import script from "./SetView.vue?vue&type=script&lang=ts&"
export * from "./SetView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports